import React from 'react';

import Badge from 'elements/Badges/Badge';

/* eslint-disable react/prop-types */
export const Standard = ({ color = 'black', children = 'Badge' }) => <Badge color={color}>{children}</Badge>;

/* eslint-enable react/prop-types */



// WEBPACK FOOTER //
// ./src/containers/elements/Badges/constants/badgesLayouts.js